import React from "react"

export const THEME_MODE_STORAGE_KEY = "admin-theme-mode"

interface LayoutContextInterface {
  themeMode: ThemeMode
  setThemeMode: (mode: ThemeMode) => void
}

interface LayoutProviderProps extends React.PropsWithChildren {}

enum ThemeMode {
  LIGHT = "light",
  DARK = "dark",
}

export { type LayoutContextInterface, type LayoutProviderProps, ThemeMode }
